export default {
  computed: {
    materialsMap() {
      const materaials = {};
      for (let key in window.materials_data) {
        materaials[key] = window.materials_data[key].metadata.name.material;
      }
      
      return materaials;
    },
    materialsSortedList() {
      let list = [];
      for (let key in this.materialsMap) {
        list.push({key, name: this.materialsMap[key]});
      }
      
      return list.sort((a, b) => {
        if (a.name === b.name) {
          return 0;
        }
        
        return a.name < b.name ? -1 : 1;
      });
    }
  }
}
